import React from "react";
import { motion } from "framer-motion";

interface SectionHeaderProps {
    title?: string;
    description?: string;
    className?: string;
    highlightedText?: string;
    regularText?: string;
    descriptionHighlight?: string;
    descriptionText?: string;
    descriptionExtra?: React.ReactNode;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ 
    title, 
    description, 
    className = "",
    highlightedText,
    regularText,
    descriptionHighlight,
    descriptionText,
    descriptionExtra
}) => {
    return (
        <div dir="rtl" className={`relative text-center mb-6 ${className}`}>
            <motion.h2
                className="text-2xl md:text-4xl font-bold pb-4 relative z-10"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
            >
                {regularText && <span className="text-gray-800">{regularText} </span>}
                {highlightedText && <span className="bg-gradient-to-r from-[#0038A8] to-[#155DFC] bg-clip-text text-transparent">{highlightedText}</span>}
                {!regularText && !highlightedText && title}
            </motion.h2>

            {(description || descriptionText || descriptionHighlight) && (
                <motion.p
                    className="text-lg max-w-4xl mx-auto leading-relaxed"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    viewport={{ once: true }}
                >
                    {descriptionHighlight && <span className="text-[#155DFC] font-medium">{descriptionHighlight} </span>}
                    {descriptionText && <span className="text-gray-600">{descriptionText}</span>}
                    {descriptionExtra}
                    {!descriptionHighlight && !descriptionText && description && <span className="text-gray-600">{description}</span>}
                </motion.p>
            )}
        </div>
    );
};

export default SectionHeader;
